
import { i18nText } from '@/locales';


import {RouterNameEnum} from '@/router/router.types';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import {Tabs} from 'ant-design-vue';
import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import {SimpleProxyForm} from '@/UI/components/Helpers/SimpleProxyForm';
import { checkUserRole, getUserData } from '@/router/Lib/helper';
import {getStudioId} from "@/UI/lib/state";

@Component({
  components: {
    BaseDataForm,
    'a-tab': Tabs,
    'a-tab-pane': Tabs.TabPane,
  },
  methods: {
    checkUserRole
  }
})
export default class TabIndex extends mixins(SimpleProxyForm) {
  tabs = [
    {
      id: RouterNameEnum.LoyaltySubscription,
      name: i18nText("Абонементы"),
      meta: {
        alias: RouterNameEnum.LoyaltySubscription,
      },
      params: {
        meta: {
          alias: RouterNameEnum.LoyaltySubscription,
        },
        name: RouterNameEnum.LoyaltySubscription,
        params: {Studio: getStudioId(this)},
      },
    },
    {
      id: RouterNameEnum.LoyaltySubscriptionType,
      name: i18nText("Типы абонементов"),
      meta: {
        alias: RouterNameEnum.LoyaltySubscriptionType,  //needToCheck
      },
      params: {
        meta: {
          alias: RouterNameEnum.LoyaltySubscriptionType,  //needToCheck
        },
        name: RouterNameEnum.LoyaltySubscriptionType,  //needToCheck
        params: {Studio: getStudioId(this)},
      },
    }
  ];

  get activeTab(): string {
    return this.tabs.find(item => item.id === this.$route.name || item.id + 'Page' === this.$route.name)?.id || this.tabs[0].id;
  }

  tabChanged(key: string): void {
    this.$router.push({name: key, params: {Studio: getStudioId(this)}});
  }

  async created(): Promise<void> {
    this.formReady = true;
  }
}
